import React from 'react';
import { Modal, Button } from 'react-bootstrap'

class ModalInline extends React.Component {
	onClose = null;

	constructor(props) {
		super(props);
		this.state = { visible: false }
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	open = (content, onClose) => {
		this.setState({ visible: true, content: content }, function () {
			this.onClose = onClose;
		});
	}

	close = () => {
		this.setState({ visible: false }, function () {
			if (this.onClose !== null && this.onClose !== undefined)
				this.onClose();

			this.onClose = null;
		});
	}

	render() {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.close}>
					<Modal.Body>
						{ this.state.content }
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.close}>Close</Button>
					</Modal.Footer>
				</Modal>
			</React.Fragment>)
	}
}

export default ModalInline;



// WEBPACK FOOTER //
// ./src/fw/modals/inline/Inline.js